import { ReactNode } from "react";
import OverflowTooltip from "components/elements/Tooltips/OverflowTooltip";

export default function AutodeskBrowserRow(p: {
  icon: ReactNode;
  label: string;
  note?: string;
  isDisabled?: boolean;
  onClick(): void;
}) {
  return (
    <button
      type="button"
      disabled={p.isDisabled}
      onClick={p.onClick}
      className="flex w-full select-none items-center gap-3 rounded-md border p-3 text-left text-sm font-light shadow-sm enabled:hover:bg-gray-50 disabled:cursor-default disabled:text-gray-400"
    >
      <span className="w-5 shrink-0">{p.icon}</span>
      <OverflowTooltip className="min-w-0 flex-1">{p.label}</OverflowTooltip>
      {p.note && <span className="shrink-0 text-xs">{p.note}</span>}
    </button>
  );
}
